export default "__VITE_ASSET__6DAt9jVX__"